import $ from "jquery";

export const init = () => {
  // -------------------------------------------------------------
  // facebook share
  // -------------------------------------------------------------
  window.fbShare = (url, title, descr, image, winWidth, winHeight) => {
    let winTop = screen.height / 2 - winHeight / 2;
    let winLeft = screen.width / 2 - winWidth / 2;
    let shareurl = encodeURIComponent(url);
    let baseURL =
      "https://www.facebook.com/dialog/share?%20app_id=1603843519910518%20&href=";
    if (typeof image != "undefined" && image.length > 0) {
      window.open(
        "" +
          baseURL +
          shareurl +
          "&display=popup&picture=" +
          image +
          "&description=" +
          descr +
          "&caption=BFDW",
        "teilen",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    } else {
      window.open(
        "" +
          baseURL +
          shareurl +
          "&display=popup&description=" +
          descr +
          "&caption=BFDW",
        "teilen",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    }
  };

  // -------------------------------------------------------------
  // twitter share
  // -------------------------------------------------------------
  window.bsShare = (url, text, image, winWidth, winHeight) => {
    let winTop = screen.height / 2 - winHeight / 2;
    let winLeft = screen.width / 2 - winWidth / 2;
    let tweeturl = encodeURIComponent(url);
    let tweettext = "";
    if (typeof image != "undefined" && "" != image) {
      tweettext += image + " - ";
    }
    window.open(
      "https://bsky.app/intent/compose?text=" + tweeturl + "&text=" + text,
      "teilen",
      "top=" +
        winTop +
        ",left=" +
        winLeft +
        ",toolbar=0,status=0,width=" +
        winWidth +
        ",height=" +
        winHeight
    );
  };

  // -------------------------------------------------------------
  // whatsapp share
  // -------------------------------------------------------------
  window.waShare = (url, text, image, winWidth, winHeight) => {
    let winTop = screen.height / 2 - winHeight / 2;
    let winLeft = screen.width / 2 - winWidth / 2;
    let shareurl = encodeURIComponent(url);
    window.open(
      "https://wa.me/?text=" + shareurl,
      "teilen",
      "top=" +
        winTop +
        ",left=" +
        winLeft +
        ",toolbar=0,status=0,width=" +
        winWidth +
        ",height=" +
        winHeight
    );
  };
};
